import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'preview' ]

  updatePreview (e) {
    this.previewTarget.src = e.currentTarget.src
  }
}
